export const BlogStatus = {
  DRAFT:     100,
  PUBLISHED: 200,
  ARCHIVED:  300,
};

export const BlogStatusConfig = {
  [BlogStatus.DRAFT]:     { label: 'Draft',     style: { bg: '#B5D4F4', border: '#378ADD', color: '#0C447C' }},
  [BlogStatus.PUBLISHED]: { label: 'Published', style: { bg: '#C0DD97', border: '#639922', color: '#27500A' }},
  [BlogStatus.ARCHIVED]:  { label: 'Archived',  style: { bg: '#FAC775', border: '#BA7517', color: '#633806' }},
};